// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__3-aBP","notes":"Notes_notes__3Jz3S"};